<script setup>
import useDates from "@/composables/useDates";
import FixText from "@/components/approval-center/partials/ui/FixText.vue";
import FixContent from "@/components/approval-center/partials/ui/FixContent.vue";
import FixPanelHeaderTitle from "@/components/approval-center/partials/ui/FixPanelHeaderTitle.vue";
import {computed} from "vue";
import KitModalHeader from "@/components/global-themed/ui/modals/KitModalHeader.vue";
import KitIcon from "@/components/approval-center/partials/kit/KitIcon.vue";
import ModalHeader from "@/components/global-themed/ui/modals/ModalHeader.vue";
import ModalHeading from "@/components/global-themed/ui/modals/ModalHeading.vue";

const props = defineProps({
  modalTitle: {
    type: String,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
});

const {formattedDate} = useDates();

const title = computed(() => {
  if(props.data.scheduled_date) {
    return `${formattedDate(props.data.scheduled_date, 'Do MMMM')} - ${props.data.title}`
  }

  return props.data.title;
})
</script>

<template>
  <KitModalHeader>
    <KitIcon
      class="tw-w-[88px]"
      state="default"
    />

    <ModalHeader>
      <ModalHeading>{{ modalTitle }}</ModalHeading>
      <FixPanelHeaderTitle>{{ title }}</FixPanelHeaderTitle>
    </ModalHeader>
  </KitModalHeader>

  <FixContent class="tw-max-h-[360px] tw-prose tw-max-w-none tw-flex tw-items-start tw-gap-8 tw-mt-8">
    <FixText>
      <div v-html="data.body" />
    </FixText>
  </FixContent>
</template>
